export default "__VITE_ASSET__DisXbDhF__"